import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {
  
  private pageTitleSubject = new BehaviorSubject<string[]>(['Agency Portal']);
  public pageTitle$ = this.pageTitleSubject.asObservable();

  setTitle(titleParts: string[]) {
    this.pageTitleSubject.next(titleParts);
  }

}
